import React from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './index.module.sass';

const Menu = (props) => {
  const { device, history, match } = props;
  const { screenSize } = device;
  const { t } = useTranslation('consultancy');

  const menuItems = t('menu', { returnObjects: true });

  return (
    <div id={styles.Menu} className={styles[screenSize]}>
      <div className={styles.grid}>
        {Array.isArray(menuItems) &&
          menuItems.map((val, key) => {
            const { name = '', link = '', icon = '' } = val;
            return (
              <div className={styles.menuItem} key={key}>
                <div className={styles.item} onClick={() => history.push(match.path + link)}>
                  <span className={`material-icons ${styles.icon}`}>{icon}</span>
                  <div className={styles.itemTitle}>{name}</div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Menu;
